import {Injectable, OnDestroy} from '@angular/core';
import {Attachment} from '@docma-mm-core/attachment/attachment';
import {AttachmentService} from '@docma-mm-core/attachment/attachment.service';
import {ImageViewerService, ViewerItem} from '@mydocma/component-library/src/lib/image-viewer';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class MmImageViewerService extends ImageViewerService<Attachment> implements OnDestroy {

  constructor(private readonly attachmentService: AttachmentService) {
    super();
    this.fullScreen$.pipe(untilDestroyed(this)).subscribe(fs => {

      if (!fs) {
        this.reset();
      } else {
        this.changeFitSizeState(1);
      }
    });
  }

  ngOnDestroy(): void {
  }

  async showInFullScreen(options: {
    currentItem?: Attachment,
    items?: Array<Attachment>,
    itemLoader?: (item: Attachment) => Promise<ViewerItem>
  }) {
    if (options?.currentItem?.data?.MimeType && !options.currentItem.data.MimeType.startsWith('image')) {
      await this.attachmentService.downloadAttachment(options?.currentItem);
      return;
    }
    this.itemLoader = options.itemLoader;
    this.currentItem = options.currentItem;
    this.items = (options.items ? options.items : [options.currentItem]).filter(a => {
      return a.data?.MimeType?.startsWith('image');
    });
    this.fullScreen = true;
  }

  private reset() {
    this.currentItem = null;
  }
}

export function sortAttachments(attachments: Attachment[]) {
  return attachments.sort((a, b) => {
    const d2 = (b.data?.CreatedOn ? new Date(b.data?.CreatedOn) : new Date("9999-12-31T23:59:59"));
    const d1 = (a.data?.CreatedOn ? new Date(a.data?.CreatedOn) : new Date("9999-12-31T23:59:59"));
    return d2.getTime() - d1.getTime();
  });
}
